import { render, staticRenderFns } from "./AssessmentLoadingScreen.vue?vue&type=template&id=ab861606&scoped=true"
import script from "./AssessmentLoadingScreen.vue?vue&type=script&lang=js"
export * from "./AssessmentLoadingScreen.vue?vue&type=script&lang=js"
import style0 from "./AssessmentLoadingScreen.vue?vue&type=style&index=0&id=ab861606&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab861606",
  null
  
)

export default component.exports